import gql from 'graphql-tag';

export const updateShiftTurnover = gql`
  mutation updateShiftTurnover($id: String!, $input: UpdateShiftTurnoverInput) {
    updateShiftTurnover(id: $id, input: $input) {
      id
      status
      shiftDate
      incomingCompletedDate
      departingCompletedDate
      createdAt
      version
      updatedAt
      businessUnit {
        id
      }
      ShiftType {
        id
        name
      }
      AOR {
        id
        name
        abbreviation
        dopGroupId
        AORSubSystems {
          id
          name
        }
      }
      ShiftDetails {
        id
        incomingDepartingFlag
        Analyst {
          id
          firstName
          lastName
        }
        fitFlag
        scadaFlag
        additionalComments
        reviewedAllSections
        ShiftTurnoverItems {
          id
          turnoverFlag
          comments
          ShiftItem {
            id
            name
            sortOrder
          }
        }
        ShiftTurnoverMitigations {
          id
          turnoverFlag
          ShiftMitigation {
            id
            name
          }
        }
      }
    }
  }
`;
